// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__APdIU","dragIcon":"Choice_dragIcon__MlXOn","left":"Choice_left__BCxu3","input":"Choice_input__wz5jF"};